import { render } from "./retouch-data.vue?vue&type=template&id=36e4b1a0"
import script from "./retouch-data.vue?vue&type=script&lang=js"
export * from "./retouch-data.vue?vue&type=script&lang=js"

import "./retouch-data.vue?vue&type=style&index=0&id=36e4b1a0&lang=css"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__